import { COMPANY_NAME_MAP } from '../company';
import { Industry, FooterContent } from 'src/types';

import financeLogo from 'src/assets/images/logos/finance-logo.png';
import financeStyles from 'src/styles/finance/footer.module.css';

import gamblingLogo from 'src/assets/images/logos/gambling-logo.png';
import gamblingStyles from 'src/styles/gambling/footer.module.css';

import insuranceLogo from 'src/assets/images/logos/insurance-logo.png';
import insuranceStyles from 'src/styles/insurance/footer.module.css';

import mobileLogo from 'src/assets/images/logos/mobile-logo.png';
import mobileStyles from 'src/styles/mobile/footer.module.css';

import retailLogo from 'src/assets/images/logos/retail-logo.png';
import retailStyles from 'src/styles/retail/footer.module.css';

export const FOOTER_CONTENT_MAP: Record<Industry, FooterContent> = {
  Finance: {
    cssStyles: financeStyles,
    logo: {
      src: financeLogo,
      alt: `${COMPANY_NAME_MAP['Finance']} Logo`,
    },
    logoText: COMPANY_NAME_MAP['Finance'],
    sections: [
      {
        header: 'Home',
        navLinks: ['Mortgages', 'Credit Cards', 'Loans'],
      },
      {
        header: 'Help',
        navLinks: ['Banking', 'Mobiler', 'Money management', 'Fraud'],
      },
      {
        header: 'Legal',
        navLinks: ['Legal info', 'Terms and conditions', 'Privacy'],
      },
      {
        header: 'About Us',
        navLinks: ['About us', 'Diversity', 'Careers', 'History'],
      },
    ],
  },
  Gambling: {
    cssStyles: gamblingStyles,
    logo: {
      src: gamblingLogo,
      alt: `${COMPANY_NAME_MAP['Gambling']} Logo`,
    },
    sections: [
      {
        header: 'Home',
        navLinks: ['Poker', 'Slots', 'Sports'],
      },
      {
        header: 'Help',
        navLinks: ['Need help?', 'Mobile app', 'Gamble aware', 'Fraud'],
      },
      {
        header: 'Legal',
        navLinks: ['Legal info', 'Terms and conditions', 'Privacy'],
      },
      {
        header: 'About Us',
        navLinks: ['About us', 'Diversity', 'Careers', 'History'],
      },
    ],
  },
  Insurance: {
    cssStyles: insuranceStyles,
    logo: {
      src: insuranceLogo,
      alt: `${COMPANY_NAME_MAP['Insurance']} Logo`,
    },
    logoText: COMPANY_NAME_MAP['Insurance'],
    sections: [
      {
        header: 'Home',
        navLinks: ['Pets', 'Contents insurance', 'Travel'],
      },
      {
        header: 'Help',
        navLinks: ['Insurance', 'Mobile', 'Money management', 'Fraud'],
      },
      {
        header: 'Legal',
        navLinks: ['Legal info', 'Terms and conditions', 'Privacy'],
      },
      {
        header: 'About Us',
        navLinks: ['About us', 'Diversity', 'Careers', 'History'],
      },
    ],
  },
  Mobile: {
    cssStyles: mobileStyles,
    logo: {
      src: mobileLogo,
      alt: `${COMPANY_NAME_MAP['Mobile']} Logo`,
    },
    logoText: COMPANY_NAME_MAP['Mobile'],
    sections: [
      {
        header: 'Home',
        navLinks: ['SIM cards', 'Boardband', 'Tech'],
      },
      {
        header: 'Help',
        navLinks: ['Troubleshoot', 'Mobile', 'Contact us', 'Fraud'],
      },
      {
        header: 'Legal',
        navLinks: ['Legal info', 'Terms and conditions', 'Privacy'],
      },
      {
        header: 'About Us',
        navLinks: ['About us', 'Diversity', 'Careers', 'History'],
      },
    ],
  },
  Retail: {
    cssStyles: retailStyles,
    logo: {
      src: retailLogo,
      alt: `${COMPANY_NAME_MAP['Retail']} Logo`,
    },
    logoText: COMPANY_NAME_MAP['Retail'],
    sections: [
      {
        header: 'Home',
        navLinks: ['Mens', 'Womens', 'Membership'],
      },
      {
        header: 'Help',
        navLinks: ['Contact us', 'Mobile app', 'Membership queries', 'Fraud'],
      },
      {
        header: 'Legal',
        navLinks: ['Legal info', 'Terms and conditions', 'Privacy'],
      },
      {
        header: 'About Us',
        navLinks: ['About us', 'Diversity', 'Careers', 'History'],
      },
    ],
  },
};
